import React, { useEffect, useRef, useState } from 'react';
import './Story.css';
import storyElephant from '../assets/wild-elephant-logo-cropped.png';
function useInView(threshold = 0.2) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}
const stats = [{
  number: '48+',
  label: 'Craft Brews'
}, {
  number: '120+',
  label: 'Menu Items'
}, {
  number: '5 Star',
  label: 'Experience'
}, {
  number: 'Always',
  label: 'Good Times'
}];
export default function Story() {
  const [ref, inView] = useInView(0.15);
  return <section id="story" ref={ref} className="story__auto-1">
      {/* Crimson accent block */}
      <div className="story__auto-2" />

      {/* Large decorative text */}
      <div className="story__auto-3">
        WILD
      </div>

      <div className="story__auto-4">
        {/* Left: visual card */}
        <div className={`story__reveal story__reveal--left ${inView ? 'story__reveal--visible' : ''}`}>
          <div className="story__auto-5">
            {/* Main card */}
            <div className="story__auto-6">
              {/* Corner ornament top-left */}
              <CornerOrnament className="story__auto-7" />
              <CornerOrnament className="story__auto-8" />

              {/* Central elephant motif */}
              <div className="story__auto-9">
                <ElephantArtDeco size={120} />
              </div>

              <div className="story__auto-10">
                "Every sip tells<br />a wild story"
              </div>
              <div className="story__auto-11" />
              <div className="story__auto-12">
                Est. Mysuru
              </div>
            </div>

            {/* Offset gold border */}
            <div style={{
            position: 'absolute',
            inset: '-8px',
            border: '1px solid rgba(230,210,173,0.15)',
            borderRadius: '2px',
            pointerEvents: 'none',
            zIndex: -1
          }} />
          </div>
        </div>

        {/* Right: text */}
        <div className={`story__reveal story__reveal--right ${inView ? 'story__reveal--visible' : ''}`}>
          <div className="story__auto-13">
            <div className="story__auto-14" />
            <span className="story__auto-15">Our Story</span>
          </div>

          <h2 className={`story__auto-16 story__typing ${inView ? 'story__typing--active' : ''}`}>
            Born from the<br />
            <span className="story__auto-17">Untamed Wild</span>
          </h2>

          <p className="story__auto-18">
            Inspired by the majestic elephant - a symbol of strength, wisdom, and untamed grace - Wild Elephant is Mysuru's most distinctive craft bar experience. We brew with passion, cook with soul, and serve with pride.
          </p>

          <p className="story__auto-19">
            Our artisan brewery crafts small-batch beers that push the boundaries of flavour. Our kitchen marries bold Indian spices with global techniques - a culinary expedition in every plate.
          </p>

          {/* Stats grid */}
          <div className="story__auto-20">
            {stats.map((s, i) => <div key={i} style={{
            opacity: inView ? 1 : 0,
            transform: inView ? 'translateY(0)' : 'translateY(20px)',
            transition: `all 0.6s ease ${0.6 + i * 0.1}s`
          }}>
                <div className="story__auto-21">
                  {s.number}
                </div>
                <div className="story__auto-22">
                  {s.label}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}
function CornerOrnament({
  style
}) {
  return <div style={{
    width: '24px',
    height: '24px',
    ...style
  }}>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 24 L0 0 L24 0" stroke="rgba(230,210,173,0.4)" strokeWidth="1" />
        <path d="M4 20 L4 4 L20 4" stroke="rgba(230,210,173,0.2)" strokeWidth="0.5" />
      </svg>
    </div>;
}
function ElephantArtDeco({
  size = 120
}) {
  return <img className="story__elephant-image" src={storyElephant} width={size} height={size} alt="Decorative elephant outline" />;
}
